// extracted by mini-css-extract-plugin
export default {"box":"Blog_box__u7pOk","mainBox":"Blog_mainBox__aN542","Image":"Blog_Image__GF35E","button":"Blog_button__K-dm1","name":"Blog_name__uCIV0","blogDetails":"Blog_blogDetails__qANXj"};